import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { LOGO_MAX_WIDTH_RATIO } from '../../../constants/ui';
import { useBrandingPathname } from '../../../hooks/useBrandingPathname';
import { useImageWithFallback } from '../../../hooks/useImageWithFallback';
import { useLogoScale } from '../../../hooks/useLogoScale';
import { selectOrgLogoCandidates } from '../../../store/selectors/derived';

export const BrandLogo = () => {
  const pathname = useBrandingPathname();

  const selectCandidates = useMemo(() => selectOrgLogoCandidates(pathname), [pathname]);
  const candidates = useSelector(selectCandidates);
  const { src, onError } = useImageWithFallback(...candidates);

  const { logoHeight } = useLogoScale();

  return (
    <Box
      component="img"
      src={src}
      alt="logo"
      onError={onError}
      sx={{
        // height drives the scale; width follows the natural aspect ratio
        height: logoHeight,
        width: 'auto',
        // A wide logo hits this cap before its configured height, and `contain` then scales the
        // whole image down to fit — so the rendered height can land under `logoHeight`. That
        // tradeoff is deliberate: overflowing into the app bar controls is worse than a logo
        // that stops growing early.
        maxWidth: `${LOGO_MAX_WIDTH_RATIO * 100}%`,
        objectFit: 'contain',
        objectPosition: 'left center',
      }}
    />
  );
};
